export const partnerRouts = {
  B2B: {
    screens: {
      OrderInfo: 'track/:orderId',
      ShopperInfo: 'meijer/shopper-info',
      OrderItemInfo: 'meijer/order-item-info',
      UserLogin: 'meijer/login',
      Reschedule: 'reschedule/:orderId',
    },
  },
};
